import React, { ReactNode } from 'react'
import { ErrorBoundary } from '@sentry/nextjs'
import ErrorPage from './ErrorPage'
import { SidebarProvider } from '../ui/sidebar'
import { AppSidebar } from './app-sidebar'
import { Navigation } from './header'
import { CartContextProvider } from '@/contexts/useCart'

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <CartContextProvider>
      <SidebarProvider>
        <AppSidebar />

        <main className="w-full overflow-auto">
          <ErrorBoundary fallback={() => <ErrorPage />}>
            <Navigation />
            <div className="px-8 container mx-auto mt-8 pb-8">{children}</div>
          </ErrorBoundary>
        </main>
      </SidebarProvider>
    </CartContextProvider>
  )
}

export default Layout
